import React from "react";
import PerformanceAnalysisMultiKillCircle from "./PerformanceAnalysisMultiKillCircle";

const PerformanceAnalysisMultiKills = (props) => {
  const { multiKills } = props;

  if (!multiKills) {
    return <div />;
  }

  const multiKillData = [
    { type: "double", amount: multiKills.doubleKills },
    { type: "triple", amount: multiKills.tripleKills },
    { type: "quadra", amount: multiKills.quadraKills },
    { type: "penta", amount: multiKills.pentaKills },
  ];

  return (
    <div className="multikills-section">
      <div className="multikill-header">
        <div className="small-header">MULTI KILLS</div>
        <div className="basic-text">You are a last hitting God. Here are all the times your penta was stolen.</div>
      </div>
      <div className="multikills">
        {multiKillData.map((dataPoint, index) => {
          return (
            <div key={index}>
              <PerformanceAnalysisMultiKillCircle data={dataPoint} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PerformanceAnalysisMultiKills;
